module.exports = __webpack_public_path__ + "images/gfr-bg-pricing-mobile.webp";